import {Component, ElementRef, isDevMode, OnInit, ViewChild} from '@angular/core';
import {environment} from "../../../../environments/environment";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MatDialogRef} from "@angular/material/dialog";
import {MAT_DATE_FORMATS} from "@angular/material/core";
import {MY_FORMATS} from "../../../utils/formats";
import {EmployeeService} from '../../../services/employee.service';
import {MatSelectChange} from "@angular/material/select";
import {AngularFirestore} from "@angular/fire/compat/firestore";
import {Employee} from "../../../interfaces/Employee";
import {Centre} from "../../../interfaces/Centres";
import {Observable} from "rxjs";
import {UserRole} from "../../rename/add-user-role/add-user-role.component";
import {uid} from "chart.js/helpers";
import {LogService} from "../../../services/log.service";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {MatSnackBar} from "@angular/material/snack-bar";
import {FirebaseErrors} from "../../../FirebaseErrors";
interface CreateUserResponse {
  uid: string;
  // add other properties if they exist in the response
}


@Component({
    selector: 'app-employee',
    templateUrl: './create-employee.html',
    styleUrls: ['./create-employee.scss'],
    providers: [
        {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS}
    ]
})


export class CreateEmployee implements OnInit {
    env = isDevMode() ? environment.testMode : environment.productionMode;
    employeeForm: any;
    centres$: Observable<Centre[]>
    submitted = false;
    files: any = [];

    data :UserRole[] = []
roles$:Observable<any>
departments$:Observable<any>
  @ViewChild('fileInput') fileInput!: ElementRef;
  constructor(public dialogRef: MatDialogRef<CreateEmployee>,
                public mFirestore: AngularFirestore,
              private readonly  snackBar : MatSnackBar,
              private readonly mLogService:LogService,
private readonly mDatabase:AngularFireDatabase,
                private employeeService: EmployeeService)
  {
    this.roles$ = this.mDatabase.list('types/Employee Roles').valueChanges()
    this.departments$ = this.mDatabase.list('types/Employee Departments').valueChanges()
        this.centres$ = this.mFirestore.collection<Centre>('ALCentres').valueChanges({idField: 'id'})

  }

    ngOnInit(): void {
        this.employeeForm = new FormGroup({
            "userName": new FormControl('', [Validators.required]),
            "email": new FormControl('', [Validators.required, Validators.email]),
            // "centreCode": new FormControl('', [Validators.required]),
            "centresAllowed": new FormControl('',
              ),
            // "email": new FormControl('', [ Validators.pattern('[a-zA-Z]*')]),
            // "employeestatus": new FormControl('', [ Validators.pattern('[a-zA-Z]*')]),
            "department": new FormControl('',),
            "jobtitle": new FormControl('', [Validators.pattern('[a-z A-Z ]*')]),
            "empCode": new FormControl('', [Validators.required]),
            "location": new FormControl(''),
            "mobile": new FormControl('', Validators.pattern('^[0-9]{10}$')),
            "role": new FormControl('', [Validators.required]),
          'profileImage':new FormControl(null, ),

          // "vehicleNo": new FormControl('MH-AK-8437', ),
            "permissions":new FormControl(this.data)
        })

    }


    cancel() {
        this.dialogRef.close()
        this.submitted = false;
        console.log(this.employeeForm.reset())
    }

    uploadFile(event: Event) {
        const target = event.target as HTMLInputElement;
        const files = target.files as FileList;
        for (let index = 0; index < files.length; index++) {
            const element = files[index];
            this.files.push(element.name)
        }
    }

    deleteAttachment(files: any) {
        this.files.splice(files, 1)
    }

    get centrecode() {
        return this.employeeForm.get('centrecode');
    }

    get employeestatus() {
        return this.employeeForm.get('employeestatus');
    }

    get employeecode() {
        return this.employeeForm.get('employeecode');
    }

    get employeerole() {
        return this.employeeForm.get('employeerole');
    }

    get firstname() {
        return this.employeeForm.get('firstname');
    }

    get lastname() {
        return this.employeeForm.get('lastname');
    }

    get email() {
        return this.employeeForm.get('email');
    }

    get middlename() {
        return this.employeeForm.get('middlename');
    }


    get mobile() {
        return this.employeeForm.get('mobile');
    }

    get city() {
        return this.employeeForm.get('city');
    }

    get street() {
        return this.employeeForm.get('address');
    }

    get state() {
        return this.employeeForm.get('state');
    }

    get pincode() {
        return this.employeeForm.get('pincode');
    }

    public findInvalidControls() {
        const invalid = [];
        const controls = this.employeeForm.controls;
        for (const name in controls) {
            if (controls[name].invalid) {
                invalid.push(name);
            }
        }
        return invalid;
    }

    onSelectCentre($event: Event) {

    }
  async createUser(): Promise<void> {
    this.submitted = true;
    // console.log("this.employeeForm.valid",this.employeeForm.value)

    if (!this.employeeForm.valid) {
      this.submitted = false;
      const invalidControls = this.findInvalidControls();
      let errorMessage = 'Please fix the following fields:\n';

      invalidControls.forEach(controlName => {
        const control = this.employeeForm.get(controlName);
        if (control?.errors) {
          switch (controlName) {
            case 'userName':
              errorMessage += '- Username is required\n';
              break;
            case 'email':
              errorMessage += control.errors['required'] ?
                '- Email is required\n' :
                '- Please enter a valid email address\n';
              break;
            case 'mobile':
              errorMessage += '- Mobile number must be 10 digits\n';
              break;
            case 'empCode':
              errorMessage += '- Employee code is required\n';
              break;
            case 'role':
              errorMessage += '- Role selection is required\n';
              break;
            case 'jobtitle':
              errorMessage += '- Job title should contain only letters\n';
              break;
            default:
              errorMessage += `- ${controlName} is invalid\n`;
          }
        }
      });

      this.snackBar.open(errorMessage, 'Close', {
        duration: 5000,
        panelClass: ['error-snackbar']
      });
      return;
    }

    try {
      const password = 'AL123456';
      const email = this.employeeForm.get('email')?.value;

      if (!email) {
        throw new Error('Email is required');
      }

      // Show loading snackbar
      const loadingSnackBarRef = this.snackBar.open('Creating user account...', '', {
        duration: undefined,
      });

      const response = await this.employeeService.createUser(email, password) as CreateUserResponse;

      if (!response?.uid) {
        throw new Error('Failed to create user: No UID received');
      }

      this.employeeForm.addControl('uid', new FormControl(response.uid));

      // Log password email sent activity
      let activity = {
        date: new Date().getTime(),
        section: 'Employee',
        action: 'Submit',
        description: `Password Email Sent to ${email}`,
        currentIp: localStorage.getItem('currentip') ?? 'unknown'
      };
      await this.mLogService.addLog(activity);

      // Add employee to database
      await this.employeeService.addEmployee(this.employeeForm.value, response.uid);

      // Log employee added activity
      activity = {
        date: new Date().getTime(),
        section: 'Employee',
        action: 'Submit',
        description: `Employee added to Employee by`,
        currentIp: localStorage.getItem('currentip') ?? 'unknown'
      };
      await this.mLogService.addLog(activity);

      // Dismiss loading snackbar
      loadingSnackBarRef.dismiss();

      // Show success message
      this.snackBar.open('Employee created successfully!', 'Close', {
        duration: 3000,
        panelClass: ['success-snackbar']
      });

      this.dialogRef.close();
    } catch (error: any) {
      // Firebase Auth specific error handling
      let errorMessage: string;

      if (error.code) {
        errorMessage = FirebaseErrors.Parse(error.code);
      } else {
        errorMessage = error.message || 'An unexpected error occurred while creating the user.';
      }

      this.snackBar.open(errorMessage, 'Close', {
        duration: 5000,
        panelClass: ['error-snackbar']
      });

      // Log the error for debugging
      console.error('Error creating user:', {
        code: error.code,
        message: error.message,
        fullError: error
      });
    }
  }



  onFileSelected(event: any): void {
    const fileInput = this.fileInput.nativeElement;
    if (fileInput.files && fileInput.files.length > 0) {
      const file = fileInput.files[0];
      this.employeeForm.patchValue({
        profileImage: file,
      })
    }
  }

  onRoleselected($event: MatSelectChange) {
    // alert ($event.value)
    this.mFirestore.collection(this.env.userPermissions).doc($event.value).collection<UserRole>('permissions').get().subscribe(res=>{
    res.docs.forEach(it=>{
      this.data?.push(it.data())
    })
    this.employeeForm.get('permissions').setValue(this.data)
    // alert(this.employeeForm.get('permissions')?.value.length)
  })

  }
}
function generateRandomPassword(length: number): string {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789!@#$&_';
    const passwordArray = [];

    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * characters.length);
        passwordArray.push(characters.charAt(randomIndex));
    }

    return passwordArray.join('');
}
